'use client';

import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import { useState, useEffect } from 'react';

export default function CustomBlocksRenderer({ content }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    
    // Unser Fix für die Anker-Sprünge (#lena-delfs)
    if (window.location.hash) {
      const id = window.location.hash.substring(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 400); // 400ms warten, bis Text und Bilder sicher da sind
    }
  }, []);

  // Wenn gar kein Text in Strapi hinterlegt wurde
  if (!content || (Array.isArray(content) && content.length === 0)) {
    return null;
  }

  // SERVER & ERSTER CLIENT-RENDER: 
  // Wir geben eine leere Hülle zurück. Das verhindert jeden Mismatch,
  // selbst wenn Strapi kaputtes HTML schickt.
  if (!mounted) {
    return <div className="strapi-blocks-wrapper" style={{ minHeight: '100px' }}></div>;
  }

  // NACH DEM LADEN: Der echte Inhalt wird eingefügt
  return (
    <div className="strapi-blocks-wrapper">
      <BlocksRenderer 
        content={content} 
        blocks={{
          paragraph: ({ children }) => <p className="content-p">{children}</p>,
          link: ({ children, url }) => {
            const isExternal = url?.startsWith('http');
            return (
              <a 
                href={url} 
                target={isExternal ? "_blank" : undefined} 
                rel={isExternal ? "noopener noreferrer" : undefined}
              >
                {children}
              </a>
            );
          },
        }}
      />
    </div>
  );
}